/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
import { updatePageDetails, changePage } from 'state/actions/app_status';
import { displayMessage } from 'state/actions/message_status';
import { requestDemoWithValidation } from 'state/actions/auth_status';
import { discardChanges } from 'state/actions/shared_form_actions';
import { displaySuccessMessage, displayErrorMessage } from 'utils/messages';

// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import RequestDemo from 'pages/auth/requestdemo/requestdemo';




/* ========== ~~~~~~~~~~ PAGE : REQUEST DEMO : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ sessionStatus, appStatus, authStatus }) => ({
    appStatus,
    fields: authStatus.requestdemo.fields,
    savingData: authStatus.requestdemo.savingData
});

// map actions
const mapDispatchToProps = dispatch => ({
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    },
    requestDemoWithValidation: (fields, data, successAction, failAction) => dispatch(requestDemoWithValidation(fields, data, successAction, failAction)),
    displayMessage: message => dispatch(displayMessage(message)),
    discardChanges: formName => dispatch(discardChanges(formName)),
    displayErrorMessage: errorMessage => dispatch(displayErrorMessage(errorMessage)),
    displaySuccessMessage: successMessage => dispatch(displaySuccessMessage(successMessage))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RequestDemo);